import DatePicker from '../../../components/Misc/DatePicker';
import Input from '../../../components/UIElements/Input';
import Select from '../../../components/UIElements/Select';

const TicketSearchModal = ({
  onChange,
  formData,
  onCancel,
  onSubmit,
}) => {
  return (
    <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="Account ID (Integer)"
            label="Account ID"
            name="account_id"
            type="number"
            onChange={onChange}
            value={formData.account_id}
          />
        </div>
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="Event ID (Integer)"
            label="Event ID"
            name="event_id"
            type="number"
            onChange={onChange}
            value={formData.event_id}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="Event Name"
            label="Event Name"
            name="event_name"
            onChange={onChange}
            value={formData.event_name}
          />
        </div>
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="Venue Name"
            label="Venue Name"
            name="venue_name"
            onChange={onChange}
            value={formData.venue_name}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/4">
          <DatePicker
            label="Event Date From"
            value={formData.event_date_from}
            onChange={onChange}
            name="event_date_from"
          />
        </div>
        <div className="w-full xl:w-1/4">
          <DatePicker
            label="Event Date To"
            value={formData.event_date_to}
            onChange={onChange}
            name="event_date_to"
          />
        </div>
        <div className="w-full xl:w-1/4">
          <DatePicker
            label="Inserted At"
            value={formData.inserted_at}
            onChange={onChange}
            name="inserted_at"
          />
        </div>
        <div className="w-full xl:w-1/4">
          <DatePicker
            label="Updated At"
            value={formData.updated_at}
            onChange={onChange}
            name="updated_at"
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="List of IDs (comma separated)"
            label="List of IDs (comma separated)"
            name="ids"
            onChange={onChange}
            value={formData.ids}
          />
        </div>
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="List of Ticket IDs (comma separated)"
            label="List of Ticket IDs (comma separated)"
            name="ticket_ids"
            onChange={onChange}
            value={formData.ticket_ids}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="List of POS Ticket IDs (comma separated)"
            label="List of POS Ticket IDs (comma separated)"
            name="pos_ticket_ids"
            onChange={onChange}
            value={formData.pos_ticket_ids}
          />
        </div>
        <div className="w-full xl:w-1/4">
          <Input
            placeholder="Section"
            label="Section"
            name="section"
            onChange={onChange}
            value={formData.section}
          />
        </div>
        <div className="w-full xl:w-1/4">
          <Input
            placeholder="Row"
            label="Row"
            name="row"
            onChange={onChange}
            value={formData.row}
          />
        </div>
      </div>
      <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
        <div className="w-full xl:w-1/2">
          <Select
            value={formData.no_count}
            name="no_count"
            options={[
              { name: 'Yes', value: true },
              { name: 'No', value: false },
            ]}
            label="Don’t return count, which can increase speed"
            onChange={onChange}
          />
        </div>
        <div className="w-full xl:w-1/2">
          <Input
            placeholder="Rotating"
            label="Has rotating barcode?"
            name="rotating"
            onChange={onChange}
            value={formData.rotating}
          />
        </div>
      </div>

      <div className="-mx-3 flex flex-wrap gap-y-4">
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onCancel}
            className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
          >
            Cancel
          </button>
        </div>
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onSubmit}
            className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};
export default TicketSearchModal;
